__turbopack_context__.v({
  "archiveToggle": "adaptive-hud-module__JKjLAq__archiveToggle",
  "attention": "adaptive-hud-module__JKjLAq__attention",
  "body": "adaptive-hud-module__JKjLAq__body",
  "brief": "adaptive-hud-module__JKjLAq__brief",
  "chevron": "adaptive-hud-module__JKjLAq__chevron",
  "context": "adaptive-hud-module__JKjLAq__context",
  "decisions": "adaptive-hud-module__JKjLAq__decisions",
  "disclosure": "adaptive-hud-module__JKjLAq__disclosure",
  "emblem": "adaptive-hud-module__JKjLAq__emblem",
  "empty": "adaptive-hud-module__JKjLAq__empty",
  "emptyDiagram": "adaptive-hud-module__JKjLAq__emptyDiagram",
  "experiment": "adaptive-hud-module__JKjLAq__experiment",
  "experimentLabel": "adaptive-hud-module__JKjLAq__experimentLabel",
  "focusMark": "adaptive-hud-module__JKjLAq__focusMark",
  "header": "adaptive-hud-module__JKjLAq__header",
  "hud": "adaptive-hud-module__JKjLAq__hud",
  "identity": "adaptive-hud-module__JKjLAq__identity",
  "instrument": "adaptive-hud-module__JKjLAq__instrument",
  "instrumentFooter": "adaptive-hud-module__JKjLAq__instrumentFooter",
  "instrumentHeading": "adaptive-hud-module__JKjLAq__instrumentHeading",
  "instruments": "adaptive-hud-module__JKjLAq__instruments",
  "itemAction": "adaptive-hud-module__JKjLAq__itemAction",
  "launcher": "adaptive-hud-module__JKjLAq__launcher",
  "launcherToggle": "adaptive-hud-module__JKjLAq__launcherToggle",
  "lock": "adaptive-hud-module__JKjLAq__lock",
  "materialActions": "adaptive-hud-module__JKjLAq__materialActions",
  "mode": "adaptive-hud-module__JKjLAq__mode",
  "openInstrument": "adaptive-hud-module__JKjLAq__openInstrument",
  "option": "adaptive-hud-module__JKjLAq__option",
  "optionActions": "adaptive-hud-module__JKjLAq__optionActions",
  "optionNumber": "adaptive-hud-module__JKjLAq__optionNumber",
  "overline": "adaptive-hud-module__JKjLAq__overline",
  "panelCount": "adaptive-hud-module__JKjLAq__panelCount",
  "plan": "adaptive-hud-module__JKjLAq__plan",
  "planNumber": "adaptive-hud-module__JKjLAq__planNumber",
  "power": "adaptive-hud-module__JKjLAq__power",
  "protocolLabel": "adaptive-hud-module__JKjLAq__protocolLabel",
  "riskMark": "adaptive-hud-module__JKjLAq__riskMark",
  "risks": "adaptive-hud-module__JKjLAq__risks",
  "runError": "adaptive-hud-module__JKjLAq__runError",
  "shoulder": "adaptive-hud-module__JKjLAq__shoulder",
  "skillGlyph": "adaptive-hud-module__JKjLAq__skillGlyph",
  "skills": "adaptive-hud-module__JKjLAq__skills",
  "srOnly": "adaptive-hud-module__JKjLAq__srOnly",
  "stageArrives": "adaptive-hud-module__JKjLAq__stageArrives",
  "status": "adaptive-hud-module__JKjLAq__status",
  "stepNode": "adaptive-hud-module__JKjLAq__stepNode",
  "stepTitle": "adaptive-hud-module__JKjLAq__stepTitle",
  "steps": "adaptive-hud-module__JKjLAq__steps",
  "summary": "adaptive-hud-module__JKjLAq__summary",
  "tabs": "adaptive-hud-module__JKjLAq__tabs",
  "trace": "adaptive-hud-module__JKjLAq__trace",
  "traceActions": "adaptive-hud-module__JKjLAq__traceActions",
  "traceBody": "adaptive-hud-module__JKjLAq__traceBody",
  "traceMark": "adaptive-hud-module__JKjLAq__traceMark",
  "traceNote": "adaptive-hud-module__JKjLAq__traceNote",
  "traceSkill": "adaptive-hud-module__JKjLAq__traceSkill",
  "tuning": "adaptive-hud-module__JKjLAq__tuning",
  "unavailable": "adaptive-hud-module__JKjLAq__unavailable",
  "vote": "adaptive-hud-module__JKjLAq__vote",
  "voteBox": "adaptive-hud-module__JKjLAq__voteBox",
});
